import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { QueryKey } from '../../domain/dtos/query-keys'
import { GetBalance } from '../../usecases/get-balance'

export const useGetBalance = () => {
  const container = useContainer()

  return useQuery([QueryKey.getBalance], () => new GetBalance(container.get(HttpClient)).execute(), {
    retry: 3,
    retryOnMount: false,
    refetchOnWindowFocus: false,
  })
}
